<template>
  <div>
    <form-wizard
      ref="formWizard"
      color="#7367F0"
      :title="null"
      :subtitle="null"
      layout="vertical"
      class="wizard-vertical mb-3"
    >
      <!-- Tab: Collection Data -->
      <tab-content
        title="Info Koleksi"
      >
        <CollectionDataForm
          ref="CollectionDataForm"
          :form="form"
          :is-edit="isEdit"
        />
      </tab-content>

      <!-- Tab: Products -->
      <tab-content
        title="Produk"
      >
        <CollectionProductForm
          v-if="isEdit"
          ref="CollectionProductForm"
          :form="form"
          :is-edit="isEdit"
        />
      </tab-content>

      <template
        slot="footer"
        slot-scope="props"
      >
        <div class="wizard-footer-left">
          <wizard-button
            v-if="props.activeTabIndex > 0"
            :style="props.fillButtonStyle"
            @click.native="props.prevTab()"
          >
            Kembali
          </wizard-button>
        </div>
        <div class="wizard-footer-right">
          <wizard-button
            v-if="props.activeTabIndex === 0"
            class="wizard-footer-right"
            :style="props.fillButtonStyle"
            :disabled="isSubmitting"
            @click.native="validateCollectionInfo"
          >
            <b-spinner
              v-if="isSubmitting"
              small
            />
            Simpan dan Lanjutkan
          </wizard-button>
        </div>
      </template>

      <template
        slot="step"
        slot-scope="props"
        :tab="props.tab"
        :transition="props.transition"
        :index="props.index"
      />
    </form-wizard>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import {
// BButton,
  BSpinner,
} from 'bootstrap-vue'

import CollectionProductForm from '@/layouts/components/form/CollectionProductForm.vue'
import CollectionDataForm from '@/layouts/components/form/CollectionDataForm.vue'

// form wizard
import { FormWizard, TabContent, WizardButton } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BSpinner,

    CollectionProductForm,
    CollectionDataForm,

    FormWizard,
    TabContent,
    WizardButton,
  },
  directives: {
    Ripple,
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        title: '',
        slug: '',
        type: '',
        is_active: '1',
        position: '',
        image: '',
        imageFile: null,
        category_id: '',
        description: '',
      },
      isPending: false,
      isSubmitting: false,
    }
  },
  computed: {
    ...mapState('collections', ['collection']),
    collectionId() {
      if (this.isEdit) {
        return this.$route.params.id
      }
      return null
    },
  },
  async created() {
    this.isPending = true

    if (this.isEdit) {
      await this.getCollection(this.collectionId)
      await this.fillData()
      this.$refs.formWizard.activateAll()

      if (this.collection.id) {
        this.$refs.formWizard.nextTab()
      }
    }

    this.isPending = false
  },
  methods: {
    ...mapActions('collections', [
      'getCollection',
      'createCollectionInfo',
      'updateCollectionInfo',
    ]),
    // submit section
    async handleSubmitInfo() {
      if (!this.isEdit) {
        const info = await this.createCollectionInfo(this.form)
        this.isSubmitting = false
        const idCollection = info.data.id
        this.$router.push(`/collections/${idCollection}/edit`)
      } else {
        await this.updateCollectionInfo({ data: this.form, collectionId: this.collectionId }).then(() => {
          this.isSubmitting = false
          this.$refs.formWizard.nextTab()
        }).catch(() => {
          this.isSubmitting = false
        })
      }

      this.isSubmitting = false
    },
    // validate section
    validateCollectionInfo() {
      this.isSubmitting = true
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          const data = this.$refs.CollectionDataForm.validationForm()
          data.then(success => {
            this.isSubmitting = true
            if (success) {
              resolve(true)
              this.handleSubmitInfo()
            } else {
              this.isSubmitting = false
              // eslint-disable-next-line prefer-promise-reject-errors
              reject(true)
            }
          }).catch(() => {
            this.isSubmitting = false
          })
        }, 1000)
      })
    },
    // Edit State Only
    fillData() {
      this.form = this.collection
      this.form.image = this.collection.image_url
      this.form.products = this.collection.products
      this.form.category_id = this.collection.category ? this.collection.category.id : ''
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-wizard.scss';
  @import '@core/scss/vue/libs/vue-select.scss';
  @import '@core/scss/vue/libs/quill.scss';
</style>
